import styled from 'styled-components';
import React from 'react';
import Pic from '../assets/images/lock.png'
import { ATTESTATION_MESSAGE } from '../constants/constants';

const YourAttestation = () => {
    return (
        <Container>
            <Emoji src={Pic} />
            <Text>
                {ATTESTATION_MESSAGE}
            </Text>
            <Linked href="https://portal.nulogic.co/account/privacy-policy" target="_blank">Privacy Policy</Linked>
        </Container>
    )
}

export default YourAttestation

const Text = styled.div`
font-weight: 500;
font-size: 24px;
line-height: 1.6;
color: #2A3039;
margin-bottom:24px;
`

const Container = styled.div`
    font-family: 'Raleway', sans-serif;
`

const Linked = styled.a`
    text-decoration: underline;
    font-weight: 500;
    font-size: 16px;
    line-height: 128%;
    color: #2D70E2;
`

const Emoji = styled.img`
    height:40px;
    margin-bottom: 40px;
`